// this is the function for toggling number of product in a row
function toggleProductGrid(lines) {
    const productGrid = document.getElementById('main-collection-product-grid');
    
    productGrid.classList.remove('collection-grid-2');
    productGrid.classList.remove('collection-grid');
    
     if (lines === 2) {
        productGrid.classList.add('collection-grid-2');
    } 
    const gridButtons = document.querySelectorAll('.st-grid-changer button');
const currentColumns = parseInt(lines); // Assuming 'lines' is the variable containing the current column value

gridButtons.forEach(button => {
    const buttonColumns = parseInt(button.getAttribute('data-grid-layout-columns'));
    const isActive = button.classList.contains('active');

    if (buttonColumns === currentColumns && !isActive) {
        button.classList.add('active'); // Add 'active' class
    } else if (buttonColumns !== currentColumns && isActive) {
        button.classList.remove('active'); // Remove 'active' class
    }
});

}


// infinte loader js
document.addEventListener('DOMContentLoaded', function () {
    const target = document.querySelector('.pagination');
  if (target) {
    window.observer1 = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (document.querySelector('.pagination .btnLoder'))
            document.querySelector('.pagination .btnLoder').click();
        }
      });
    });

    window.observer1.observe(target);
    window.onClickCollectionPagination = async (link, event) => {
      event.preventDefault();

      link.style.width = `${link.offsetWidth}px`;
      link.style.height = `${link.offsetHeight}px`;
      link.innerHTML = `
         
      <div class="st-results-loader">
      <div class="result-loading" style="text-align: center">
     <span class="st-spinner">
                          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: rgb(255, 255, 255,0); display: block; shape-rendering: auto;" width="200px" height="200px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"><g transform="rotate(0 50 50)"><rect x="48" y="24" rx="2" ry="2.4" width="4" height="12" fill="#000000"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.9166666666666666s" repeatCount="indefinite"/></rect></g><g transform="rotate(30 50 50)"><rect x="48" y="24" rx="2" ry="2.4" width="4" height="12" fill="#000000"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.8333333333333334s" repeatCount="indefinite"/></rect></g><g transform="rotate(60 50 50)"><rect x="48" y="24" rx="2" ry="2.4" width="4" height="12" fill="#000000"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.75s" repeatCount="indefinite"/></rect></g><g transform="rotate(90 50 50)"><rect x="48" y="24" rx="2" ry="2.4" width="4" height="12" fill="#000000"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.6666666666666666s" repeatCount="indefinite"/></rect></g><g transform="rotate(120 50 50)"><rect x="48" y="24" rx="2" ry="2.4" width="4" height="12" fill="#000000"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.5833333333333334s" repeatCount="indefinite"/></rect></g><g transform="rotate(150 50 50)"><rect x="48" y="24" rx="2" ry="2.4" width="4" height="12" fill="#000000"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.5s" repeatCount="indefinite"/></rect></g><g transform="rotate(180 50 50)"><rect x="48" y="24" rx="2" ry="2.4" width="4" height="12" fill="#000000"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.4166666666666667s" repeatCount="indefinite"/></rect></g><g transform="rotate(210 50 50)"><rect x="48" y="24" rx="2" ry="2.4" width="4" height="12" fill="#000000"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.3333333333333333s" repeatCount="indefinite"/></rect></g><g transform="rotate(240 50 50)"><rect x="48" y="24" rx="2" ry="2.4" width="4" height="12" fill="#000000"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.25s" repeatCount="indefinite"/></rect></g><g transform="rotate(270 50 50)"><rect x="48" y="24" rx="2" ry="2.4" width="4" height="12" fill="#000000"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.16666666666666666s" repeatCount="indefinite"/></rect></g><g transform="rotate(300 50 50)"><rect x="48" y="24" rx="2" ry="2.4" width="4" height="12" fill="#000000"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.08333333333333333s" repeatCount="indefinite"/></rect></g><g transform="rotate(330 50 50)"><rect x="48" y="24" rx="2" ry="2.4" width="4" height="12" fill="#000000"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite"/></rect></g><!-- [ldio] generated by https://loading.io/ --></svg>
                        </span>
      </div>
      </div>

    `;

      const respoonse = await fetch(link.getAttribute('href'));
      const data = await respoonse.text();
      const parser = new DOMParser();
      const newDocument = parser.parseFromString(data, 'text/html');

      document
        .querySelector('.prod.list-view .grid--uniform')
        .insertAdjacentHTML('beforeend', newDocument.querySelector('.prod.list-view .grid--uniform').innerHTML);

      document
        .querySelector('.pagination')
        .replaceWith(newDocument.querySelector('.pagination'));

      window.observer1.observe(document.querySelector('.pagination'));
    };
  }
  });


$(document).ready(function() {

$('.available.quick-add-btn.js-quick-add-btn').click(function(event){
      console.log('.available.quick-add-btn.js-quick-add-btn');
      $('body').prop('disabled', true)
      $('body').prop('style', 'opacity:1; pointer-events: none; filter: initial; overflow: hidden;')
      event.currentTarget.classList.add('btn--loading')
      var dataVariantId = event.currentTarget.attributes['data-id'].value ;
      var productHandle = event.currentTarget.attributes['product-url'].value ;
      $('.atc-popup').show()
      // updateQty(dataVariantId, productHandle, true)
      let formData = {
       'items': [{
        'id': dataVariantId,
        'quantity': 1
        }]
      };
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      }).then(response => {
        // setTimeout(update_cart_price(),1500);
        event.currentTarget.classList.remove('btn--loading')
        $('.atc-popup').hide()
        $('body').prop('disabled', false)
        $('body').prop('style', 'opacity:1;  pointer-events: all; filter: initial; overflow:hidden;')
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
              detail: {
                product: response,
                addToCartBtn: event
              }
        }));
      }).catch((error) => {
        console.error('Error:', error);
      });
    })
  
});

